import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatChannelEventDate } from '../../utils/channelDateUtils';
import { FALLBACK_IMAGE_SRC } from '../../utils/ImageUtils';
import GeoUnavailable from '../common/GeoUnavailable';
import WatchOn from '../common/WatchOn';
import './ResultCard.css';

/**
 * One search hit (see SearchService): a card linking to its page. Media opens its watch page,
 * fighters and events web's own pages, news its bkfc.com page in a new tab. A media hit shows its
 * date; the others a small type label.
 */
const ResultCard = ({ result = {} }) => {
  const [imageError, setImageError] = useState(false);
  const geoBlocked = result.geo_ok === false;
  const dateLabel = formatChannelEventDate(result.starts_at);
  const body = (
    <>
      <div className="relative overflow-hidden rounded-lg aspect-video w-full">
        {geoBlocked && <GeoUnavailable />}
        {result.watch_on && (
          <div className="absolute z-20 top-2 left-2">
            <WatchOn watchOn={result.watch_on} badge />
          </div>
        )}
        <img
          src={imageError || !result.thumbnail ? FALLBACK_IMAGE_SRC : result.thumbnail}
          alt={result.title}
          className={`object-cover w-full h-full transition-transform duration-300 hover:scale-105${
            geoBlocked ? ' opacity-40 grayscale' : ''
          }`}
          onError={() => setImageError(true)}
          loading="lazy"
        />
      </div>
      <div className="result-card-meta-block">
        {result.label && <p className="result-card-date">{result.label}</p>}
        <h3 className="result-card-title">{result.title}</h3>
        {!result.label && dateLabel && <p className="result-card-date">{dateLabel}</p>}
      </div>
    </>
  );
  const className = 'block flex-shrink-0 cursor-pointer channel-card';
  if (!result.link) {
    return null;
  }
  return result.link.to ? (
    <Link to={result.link.to} className={className}>
      {body}
    </Link>
  ) : (
    <a href={result.link.href} target="_blank" rel="noopener noreferrer" className={className}>
      {body}
    </a>
  );
};

export default ResultCard;
